import ApiClient from './ApiClient';

class RemindersAPI extends ApiClient {
  constructor() {
    super('reminders', { accountScoped: true });
  }
}

export default new RemindersAPI();
